exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-gallery-item-edit-dialog {\n  display: block;\n}", ""]);

// exports
